import { Card } from '@yleisradio/areena-types';
import { sanitizeHtmlId } from 'utils/ui-helpers';
import styles from './SimpleCard.module.scss';
import { useEffect, useState } from 'react';
import { useControl } from 'components/Controls/Control/useControl';
import { useTranslation } from 'hooks/useTranslation';
import { Button } from 'components/Button';

interface Props {
  index: number;
  card: Card;
  cardKey: string;
  selectedCardIndexes: number[];
  handleCheckboxChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => void;
}

export const SimpleCard: React.FC<Props> = ({
  index,
  card,
  cardKey,
  selectedCardIndexes,
  handleCheckboxChange,
}) => {
  const titleId = sanitizeHtmlId(cardKey + 'title');
  const [isChecked, setIsChecked] = useState(false);

  const { controls = [] } = card;
  const playControl = controls.find((c) => c.tag === 'play');

  const { control, action, executingAction } = useControl({
    control: playControl,
  });

  const onClick = !executingAction ? action : undefined;
  const t = useTranslation();

  useEffect(
    function clearCheckedStates() {
      if (selectedCardIndexes.length === 0) {
        setIsChecked(false);
      }
    },
    [selectedCardIndexes]
  );

  const toggleIsChecked = () => {
    setIsChecked(!isChecked);
  };

  return (
    <div
      data-testid="card"
      aria-labelledby={titleId}
      className={styles.container}
    >
      <label
        aria-label="toggle-queue-card"
        className={styles.queueCheckBoxLabel}
      >
        <input
          type="checkbox"
          className={styles.queueCheckBox}
          checked={isChecked}
          onChange={(event) => {
            handleCheckboxChange(event, index);
            toggleIsChecked();
          }}
          value={index}
        />
      </label>
      <div className={styles.cardTextContentWrapper}>
        <div className={styles.cardTitle}>
          <Button
            pointer={control?.destination}
            text={card.title || ''}
            disabled={!!control?.disabled}
            onClick={onClick}
            variant="text"
            size="sm"
            padding="none"
            aria-label={t('play')}
            textAlign="left"
          />
        </div>
        <span className={styles.cardDescription}>{card.description}</span>
      </div>
    </div>
  );
};
